"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurgerStackRequestBodyToJSON = exports.BurgerStackRequestBodyFromJSONTyped = exports.BurgerStackRequestBodyFromJSON = void 0;
function BurgerStackRequestBodyFromJSON(json) {
    return BurgerStackRequestBodyFromJSONTyped(json, false);
}
exports.BurgerStackRequestBodyFromJSON = BurgerStackRequestBodyFromJSON;
function BurgerStackRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'money': json['money'],
    };
}
exports.BurgerStackRequestBodyFromJSONTyped = BurgerStackRequestBodyFromJSONTyped;
function BurgerStackRequestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'money': value.money,
    };
}
exports.BurgerStackRequestBodyToJSON = BurgerStackRequestBodyToJSON;
